import { useQueryClient } from 'react-query';

import { useDelete } from '../../utils/reactQuery';
import { ApiRoutesEnum } from '../../utils/routes';

export const useDeleteClientFilter = () => {
  const queryClient = useQueryClient();
  return useDelete({
    url: ApiRoutesEnum.clientsDeleteFilter,
    onSuccess: () => {
      queryClient.invalidateQueries([ApiRoutesEnum.clientsFilters]);
    },
  });
};
